import { createSelector } from '@reduxjs/toolkit';
import { fetchStatuses } from '../../../../constants/fetchStatuses';
import { ReducerState } from '../../../store.types';

export const companyEmployeeSelector = ({ companyEmployee }: ReducerState) => companyEmployee;

export const companyEmployeesLoadingSelector = createSelector(
  companyEmployeeSelector,
  ({ fetchCompanyEmployeesStatus }) => fetchCompanyEmployeesStatus === fetchStatuses.pending,
);

export const companyEmployeeCreateLoadingSelector = createSelector(
  companyEmployeeSelector,
  ({ createCompanyEmployeeStatus }) => createCompanyEmployeeStatus === fetchStatuses.pending,
);

export const companyEmployeeUploadCsvLoadingSelector = createSelector(
  companyEmployeeSelector,
  ({ uploadCompanyEmployeesCsvStatus }) => uploadCompanyEmployeesCsvStatus === fetchStatuses.pending,
);

export const companyEmployeeLoadingSelector = createSelector(
  companyEmployeeSelector,
  ({ fetchCompanyEmployeeStatus }) => fetchCompanyEmployeeStatus === fetchStatuses.pending,
);

export const companyEmployeeUpdateLoadingSelector = createSelector(
  companyEmployeeSelector,
  ({ updateCompanyEmployeeStatus }) => updateCompanyEmployeeStatus === fetchStatuses.pending,
);

export const companyEmployeeDeleteLoadingSelector = createSelector(
  companyEmployeeSelector,
  ({ deleteCompanyEmployeeStatus }) => deleteCompanyEmployeeStatus === fetchStatuses.pending,
);

export const companyEmployeeRestoreLoadingSelector = createSelector(
  companyEmployeeSelector,
  ({ restoreCompanyEmployeeStatus }) => restoreCompanyEmployeeStatus === fetchStatuses.pending,
);

export const companyEmployeeActivateLoadingSelector = createSelector(
  companyEmployeeSelector,
  ({ activateCompanyEmployeeStatus }) => activateCompanyEmployeeStatus === fetchStatuses.pending,
);

export const companyEmployeeInactivateLoadingSelector = createSelector(
  companyEmployeeSelector,
  ({ inactivateCompanyEmployeeStatus }) => inactivateCompanyEmployeeStatus === fetchStatuses.pending,
);
